const authConfig = {
  Cognito: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_USERPOOLID,
    userPoolClientId: process.env.REACT_APP_USERPOOLCLIENTID,
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
  },
};

const apiConfig = {
  GraphQL: {
    endpoint: process.env.REACT_APP_GRAPHQLENDPOINT,
    region: process.env.REACT_APP_AWS_REGION,
    defaultAuthMode: 'userPool',
  },
};

const storageConfig = {
  S3: {
    bucket: process.env.REACT_APP_STORAGE_BUCKET,
    region: process.env.REACT_APP_AWS_REGION,
  },
};

const outputs = {
  Auth: authConfig,
  API: apiConfig,
  Storage: storageConfig,
};

export default outputs;
